import React, { useEffect, useState } from "react";
import "./RequestCard.css";
import userLayer from "../../images/userLayer.png";
import profile from "../images/profile.png";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Oval } from "react-loader-spinner";
import { toast } from "react-toastify";
import { FaCaretDown } from "react-icons/fa";
import { FaCaretRight } from "react-icons/fa";

import ic_chip_division from "../../images/ic_chip_division.svg";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";

const RequestCard = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [selectedTab, setSelectedTab] = useState("Leave");

  const [generalTab, setGeneralTab] = useState("");

  const [leaveApiLaoder, setLeaveApiLoader] = useState(false);

  const [generalApiLoader, setGeneralApiLoader] = useState(false);

  const navigate = useNavigate();

  const [leavePending, setLeavePending] = useState(null);

  const [leaveRejected, setLeaveRejected] = useState(null);

  const [leaveApproved, setLeaveApproved] = useState(null);

  const [generalReqData, setGeneralReqData] = useState(null);

  const [approvalNote, setApprovalNote] = useState("");

  const [approvalLoader, setApprovalLoader] = useState(false);

  const [popDisplay, setPopDisplay] = useState(false);

  const [rejectPopDisplay, setRejectPopDisplay] = useState(false);

  const [RejectNote, setRejectNote] = useState("");

  const [rejectLoader, setRejectLoader] = useState(false);

  const [empList, setEmpList] = useState("");

  const [portNo, setPortNo] = useState("");

  const [empId, setEmpID] = useState("");

  const [base_url, setBaseUrl] = useState(`${base_url_from_axios_config}/`);

  // Fetch data from localStorage
  const userDataString = localStorage.getItem("BondTimeLoginUserData");

  // Parse data into an array
  const userData = userDataString ? JSON.parse(userDataString) : [];

  // Extract salesman_name values
  const salesmanNames = userData.map((user) => user.salesman_name?.trim());

  // Log the result
  // console.log(salesmanNames);

  useEffect(() => {
    const storedLoginUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];

    const storedPortData =
      JSON.parse(localStorage.getItem("BondTimeportNoData")) || [];

    // if (storedLoginUserDataArray.length > 0) {
    //     setEmpID(storedLoginUserDataArray[0].EMPID)
    //     setLoggedEmpID(storedLoginUserDataArray[0].EMPID)
    // }

    if (storedPortData) {
      setPortNo(storedPortData[0].PORTNO);
    }
  }, []);

  const closeApprovalClick = () => {
    setPopDisplay(false);
    setApprovalNote("");
  };

  const closeRejectClick = () => {
    setRejectPopDisplay(false);
    setRejectNote("");
  };

  const submitApproval = async (item) => {
    setApprovalLoader(true);
    try {
      const api = `${base_url}api/PersonalInfoRequestStatusUpdate/${companyCode}/APPROVED/${item.serialCode}/${salesmanNames[0]}/${approvalNote}`;

      const response = await axios.post(api);

      if (response.status === 200) {
        setPopDisplay(false);
        toast.success("Request Approved");
        setApprovalNote("");
        fetchGeneralReqData();
        setApprovalLoader(false);
      }

      // console.log('submitApprovalApi', api)
    } catch (error) {
      console.log("submitApproval", error);
      toast.error("Error Updating Request");
      setApprovalLoader(false);
    }
  };

  const submitReject = async (item) => {
    setRejectLoader(true);
    try {
      const api = `${base_url}api/PersonalInfoRequestStatusUpdate/${companyCode}/REJECTED/${item.serialCode}/${salesmanNames[0]}/${RejectNote}`;

      const response = await axios.post(api);

      if (response.status === 200) {
        setRejectPopDisplay(false);
        toast.success("Request Rejected");
        setRejectNote("");
        fetchGeneralReqData();
        setRejectLoader(true);
      }

      // console.log('submitApprovalApi', api)
    } catch (error) {
      console.log("submitReject", error);
      toast.error("Error Updating Request");
      setRejectLoader(true);
    }
  };

  useEffect(() => {
    setLeavePending(null);
    setLeaveApiLoader(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${base_url}api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`,
        );
        setLeavePending(response.data);
        setLeaveApiLoader(false);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setLeaveApiLoader(false);
      }
    };

    if (base_url) {
      fetchData();
    }
  }, [base_url]);
  useEffect(() => {
    setLeaveRejected(null);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${base_url}api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`,
        );
        setLeaveRejected(response.data);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    if (base_url) {
      fetchData();
    }
  }, [base_url]);
  useEffect(() => {
    setLeaveApproved(null);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${base_url}api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`,
        );
        setLeaveApproved(response.data);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    if (base_url) {
      fetchData();
    }
  }, [base_url]);

  const fetchGeneralReqData = async () => {
    setGeneralApiLoader(true);
    try {
      const response = await axios.get(
        `${base_url}api/PersonalInfoRequestList/${companyCode}/${generalTab}/${empId ? empId : "-"}/-`,
      );

      if (response.status === 200) {
        setGeneralReqData(response.data);
        setGeneralApiLoader(false);
      }
      setGeneralApiLoader(false);
    } catch (error) {
      console.error("Error fetchGeneralReqData data:", error.message);
      setGeneralApiLoader(false);
    }
  };

  useEffect(() => {
    if (generalTab !== "") {
      fetchGeneralReqData();
    }
  }, [generalTab, empId]);

  useEffect(() => {
    const fetchEmpListData = async () => {
      try {
        const response = await axios.get(
          `${base_url}api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
        );
        setEmpList(response.data); // Save response data to state
      } catch (error) {
        console.log("fetchEmpListDataErr", error);
      }
    };

    if (base_url) {
      fetchEmpListData();
    }

    // if (portNo) {
    //     fetchEmpListData()
    // }
  }, [base_url]);

  // console.log('generalReqData', generalReqData)

  // console.log('generalTab', generalTab)

  const getProfilePic = (dataFromImagePath) => {
    console.log("dataFromImagePath:", dataFromImagePath);
    if (dataFromImagePath) {
      // Extract the file name and extension from the last entry
      const filePath = dataFromImagePath.replace(/\\/g, "/");
      const fileName = filePath.split("/").pop(); // Extracts the last part (filename with extension)
      console.log("fileName:", fileName);

      console.log(
        "img src:",
        `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`,
      );
      // Construct the full URL for the image
      return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
    }
  };
  const onCardClick = ()=>{
    console.log('onCardClick clicked')
    navigate('/admin/leaveapproval')
}
  return (
    <div className="ReqCardWrapper">
      <div className="ReqCardCont">
        <div className="ReqHead">
          <div className="ReqTabCont">
            <div className="d-flex">
              <div
                className={`ReqTabLeaveButton ${selectedTab === "Leave" ? "TabButtonActive" : ""}`}
                onClick={() => setSelectedTab("Leave")}
              >
                Leave
              </div>
              <div
                className={`ReqTabGeneralButton ${selectedTab === "General" ? "TabButtonActive" : ""}`}
                onClick={() => {
                  setGeneralTab("PENDING");
                  setSelectedTab("General");
                }}
              >
                General
              </div>
            </div>

            <div>
              <div
                className="UserDropToggler"
                // type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {empId ? empId : "All"} <FaCaretDown />
              </div>

              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li onClick={() => setEmpID("")}>
                  <a class="dropdown-item">All</a>
                </li>

                {empList &&
                  empList.map((item, index) => (
                    <li key={index} onClick={() => setEmpID(item.EmpId)}>
                      <a class="dropdown-item" href="#">
                        {item.EmpId}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          {selectedTab === "Leave" && (
            <div className="LeaveReqHeadTabs mt-2">
              <div
                className="rounded-full w-32 flex justify-between items-center bg-green-100 px-2 py-1 text-green-600 font-semibold"
                onClick={() => navigate("/admin/leavePage")}
              >
                <div>Approved {leaveApproved ? leaveApproved.length : 0}</div>
                <div>
                  <FaCaretRight />
                </div>
              </div>
              <div
                className="rounded-full  w-28  flex justify-between items-center bg-red-100 px-2 py-1 text-red-600 font-semibold"
                onClick={() => navigate("/admin/leavePage")}
              >
                Rejected {leaveRejected ? leaveRejected.length : 0}
                <FaCaretRight />
              </div>
            </div>
          )}

          {selectedTab === "General" && (
            <div className="ReqTabContTab mt-2">
              <div
                className={`ReqTabLeaveButton ${generalTab === "PENDING" ? "GeneralTabTypeActive GeneralTabType me-2" : "GeneralTabType me-2"}`}
                onClick={() => setGeneralTab("PENDING")}
              >
                Requested
              </div>
              <div
                className={`ReqTabGeneralButton ${generalTab === "APPROVED" ? "GeneralTabTypeActive GeneralTabType me-2" : "GeneralTabType me-2"}`}
                onClick={() => setGeneralTab("APPROVED")}
              >
                Approved
              </div>
              <div
                className={`ReqTabGeneralButton ${generalTab === "REJECTED" ? "GeneralTabTypeActive GeneralTabType me-2" : "GeneralTabType me-2"}`}
                onClick={() => setGeneralTab("REJECTED")}
              >
                Rejected
              </div>
            </div>
          )}
        </div>

        <div className="bg-yellow-400. h-50 ">
          {/* <table cellpadding="10" cellspacing="0" className="ReqTable">
                        <thead className="ReqThead">
                            <tr>
                                <td>Name</td>
                                <td>Period</td>
                                <td>Type</td>
                                <td>Status</td>
                                <td>Date</td>
                                <td>Notes</td>
                            </tr>
                        </thead>
                    </table>

                    <div className="ReqTableBodyWrapper">
                        <table cellpadding="10" cellspacing="0" className="ReqTable">
                            <tbody className="ReqTableBody">
                                {dummyData.map((item, index) => {
                                    const { statusClass, textClass, statusBody } = getStatusClasses(item.status);
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <div className="ReqUserTD">
                                                    <div>
                                                        <img src={profile} alt="" className="ReqTableUserImg" />
                                                    </div>
                                                    <div className="ReqUserDetailsTD">
                                                        <div className="ReqUserNameTD">{item.name}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{item.period}</td>
                                            <td>{item.type}</td>
                                            <td className={`${statusBody}`}>
                                                <div className="ReqTDStatusBox">
                                                    <div className={`ReqStatus ${statusClass}`}></div>
                                                    <div className="StatusText">{item.status}</div>
                                                </div>
                                            </td>
                                            <td>{item.date}</td>
                                            <td>{item.notes}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div> */}
          {selectedTab === "Leave" && leaveApiLaoder && (
            <Oval height="40" width="40" />
          )}

          {selectedTab === "General" && generalApiLoader && (
            <Oval height="40" width="40" />
          )}

          {selectedTab === "Leave" &&
            leavePending &&
            leavePending.length > 0 && (
              <div className="request_grid h-full">
                {leavePending.map((item, index) => {
                  return (
                    <div className="request_grid_item flex flex-col my-2 justify-center items-center shadow-md rounded-lg " onClick={onCardClick}>
                      <span className="">
                        <img
                          className=" profilePicInRequest"
                          src={getProfilePic(item.imagepath)}
                        />
                        {/* <img className='profilePicInRequest' src={`https://cubixweberp.com:229/BONDTIME_EMP_IMG/CBX006_time_133809795951662223.jpg`} /> */}
                      </span>

                      <p className="font-semibold text-xs my-1">
                        {item.Name ? item.Name : "--"}
                      </p>

                      <p className="jobtitle-request-card my-1">
                        {item.JobTitle ? item.JobTitle : "--"}
                      </p>

                      <p className="me-4 mt-2 from-to-request-card my-1 ">
                        {item.FromDate
                          ? new Date(item.FromDate).toLocaleDateString()
                          : "--"}
                        -
                        {item.ToDate
                          ? new Date(item.ToDate).toLocaleDateString()
                          : "--"}
                      </p>
                      <p className="text-xs">
                        {item.Reason
                          ? item.Reason
                          : "Reason not specified my-1"}
                      </p>
                      <p>
                        {item.Division ? (
                          <span className="division-badge flex justify-center items-center mt-2 mb-1">
                            <img
                              src={ic_chip_division}
                              style={{ width: "10px", marginRight: "5px" }}
                            />
                            {item.Division}
                          </span>
                        ) : (
                          "--"
                        )}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}

          {selectedTab === "Leave" &&
            (!leavePending || leavePending.length === 0) && (
              <div
                style={{
                  textAlign: "center",
                  color: "#d5c9c9",
                  fontSize: "18px",
                }}
              >
                No Data Available
              </div>
            )}

          {selectedTab === "General" &&
            generalReqData &&
            generalReqData.length > 0 && (
              <div className="request_grid">
                {generalReqData.map((item, index) => {
                  return (
                    <div className="request_grid_item mt-4">
                      <span>
                        <img
                          className="profilePicInRequest"
                          src={getProfilePic(item.imagepath)}
                        />
                      </span>

                      <p>
                        {item.FistName ? item.FistName : ""}
                        {item.LastName ? item.LastName : ""}
                      </p>

                      <p className="jobtitle-request-card">
                        {item.JobTitle ? item.JobTitle : "--"}
                      </p>

                      <p className="me-4 mt-2 from-to-request-card">
                        {item.FromDate
                          ? new Date(item.FromDate).toLocaleDateString()
                          : "--"}
                        -
                        {item.ToDate
                          ? new Date(item.ToDate).toLocaleDateString()
                          : "--"}
                      </p>
                      <p>
                        {item.Reason ? item.Reason : "Reason not specified"}
                      </p>
                      <p>
                        {item.Division ? (
                          <span className="division-badge">
                            <img
                              src={ic_chip_division}
                              style={{ width: "15px" }}
                            />
                            {item.Division}
                          </span>
                        ) : (
                          "--"
                        )}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}

          {selectedTab === "General" &&
            (!generalReqData || generalReqData.length === 0) && (
              <div
                style={{
                  textAlign: "center",
                  color: "red",
                }}
              >
                No Data Available
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default RequestCard;
